export interface Concert {
  id: string;
  artist_name: string;
  title: string;
  genre: string;
  date: string;
  venue: string;
  location: string;
  status: 'En cours' | 'À venir' | 'Bientôt' | 'Terminé';
  poster_url: string;
  price: string;
}

export const concerts: Concert[] = [
  {
    id: 'c-1',
    artist_name: 'Santrinos Raphael',
    title: 'Tournée Maladie d&apos;Amour',
    genre: 'AfroRnB',
    date: '2026-08-28',
    venue: 'Palais des Congrès',
    location: 'Lomé, Togo',
    status: 'En cours',
    poster_url:
      'https://readdy.ai/api/search-image?query=Live%20concert%20poster%20featuring%20an%20African%20afrobeats%20superstar%20performing%20on%20stage%20with%20dramatic%20warm%20stage%20lighting%20microphone%20in%20hand%20crowd%20silhouettes%20bold%20modern%20typography%20professional%20event%20poster%20rich%20warm%20golden%20tones%20high%20detail&width=720&height=1000&seq=concert-1&orientation=portrait',
    price: '10 000 FCFA',
  },
  {
    id: 'c-2',
    artist_name: 'Kiko Golden Boy',
    title: 'Business Class Live',
    genre: 'Pop / Afro',
    date: '2026-08-15',
    venue: 'Palais des Congrès',
    location: 'Lomé, Togo',
    status: 'Terminé',
    poster_url:
      'https://readdy.ai/api/search-image?query=African%20hip%20hop%20rap%20concert%20poster%20with%20a%20rapper%20performing%20energetically%20dramatic%20stage%20lights%20crowd%20hands%20raised%20bold%20urban%20design%20professional%20concert%20poster%20warm%20tones%20with%20golden%20accents%20high%20detail&width=720&height=1000&seq=concert-2&orientation=portrait',
    price: '15 000 FCFA',
  },
  {
    id: 'c-3',
    artist_name: 'Chorale Gloire',
    title: 'Nuit de Louange',
    genre: 'Gospel',
    date: '2026-09-26',
    venue: 'Temple de la Réconciliation',
    location: 'Lomé, Togo',
    status: 'À venir',
    poster_url:
      'https://readdy.ai/api/search-image?query=African%20gospel%20music%20concert%20poster%20with%20a%20choir%20singing%20under%20warm%20golden%20spotlights%20uplifting%20atmosphere%20elegant%20modern%20design%20professional%20event%20poster%20rich%20warm%20amber%20tones%20high%20detail&width=720&height=1000&seq=concert-3&orientation=portrait',
    price: '5 000 FCFA',
  },
  {
    id: 'c-4',
    artist_name: 'Groupe Kinkéliba',
    title: 'Festival des Rythmes Ancestraux',
    genre: 'Musique Traditionnelle',
    date: '2026-10-10',
    venue: 'Place des Fêtes',
    location: 'Kara, Togo',
    status: 'Bientôt',
    poster_url:
      'https://readdy.ai/api/search-image?query=Traditional%20African%20music%20festival%20poster%20with%20drummers%20in%20colorful%20attire%20festive%20stage%20warm%20sunset%20lighting%20bold%20modern%20typography%20professional%20concert%20poster%20rich%20warm%20earthy%20tones%20high%20detail&width=720&height=1000&seq=concert-4&orientation=portrait',
    price: 'Gratuit',
  },
  {
    id: 'c-5',
    artist_name: 'Almok',
    title: 'Nononini Tour',
    genre: 'R&B / Afro',
    date: '2026-10-24',
    venue: 'Hôtel 2 Février',
    location: 'Lomé, Togo',
    status: 'Bientôt',
    poster_url:
      'https://readdy.ai/api/search-image?query=African%20R%20and%20B%20concert%20poster%20with%20a%20soulful%20male%20singer%20under%20soft%20warm%20spotlights%20romantic%20mood%20elegant%20modern%20typography%20professional%20event%20poster%20rich%20warm%20golden%20tones%20high%20detail&width=720&height=1000&seq=concert-5&orientation=portrait',
    price: '12 000 FCFA',
  },
  {
    id: 'c-6',
    artist_name: 'Désiré Amouzou',
    title: 'One Man Show : Rire Garanti',
    genre: 'Humour',
    date: '2026-11-07',
    venue: 'Théâtre National',
    location: 'Lomé, Togo',
    status: 'Bientôt',
    poster_url:
      'https://readdy.ai/api/search-image?query=African%20comedy%20show%20poster%20with%20a%20comedian%20in%20expressive%20pose%20on%20a%20colorful%20stage%20bright%20festive%20lighting%20playful%20modern%20design%20professional%20event%20poster%20warm%20vibrant%20colors%20high%20detail&width=720&height=1000&seq=concert-6&orientation=portrait',
    price: '8 000 FCFA',
  },
  {
    id: 'c-7',
    artist_name: 'Himra',
    title: 'Concert Live à Lomé',
    genre: 'Afrobeats',
    date: '2026-11-21',
    venue: 'Stade de Kégué',
    location: 'Lomé, Togo',
    status: 'À venir',
    poster_url:
      'https://readdy.ai/api/search-image?query=African%20afrobeats%20superstar%20performing%20on%20a%20huge%20stadium%20stage%20with%20dramatic%20warm%20lighting%20crowd%20silhouettes%20and%20confetti%20bold%20modern%20concert%20poster%20professional%20event%20design%20rich%20warm%20golden%20tones%20high%20detail&width=720&height=1000&seq=concert-7&orientation=portrait',
    price: '20 000 FCFA',
  },
  {
    id: 'c-8',
    artist_name: 'Toofan',
    title: 'GWETA 20 ans — le concert anniversaire',
    genre: 'Afropop',
    date: '2026-12-05',
    venue: 'Palais des Congrès',
    location: 'Lomé, Togo',
    status: 'À venir',
    poster_url:
      'https://readdy.ai/api/search-image?query=Dynamic%20African%20afropop%20duo%20performing%20energetic%20choreography%20on%20a%20vibrant%20stage%20with%20colorful%20lights%20and%20dancers%20bold%20festive%20concert%20poster%20professional%20event%20design%20warm%20golden%20tones%20high%20detail&width=720&height=1000&seq=concert-8&orientation=portrait',
    price: '15 000 FCFA',
  },
  {
    id: 'c-9',
    artist_name: 'King Mensah',
    title: 'La Voix d\u2019Or — concert hommage',
    genre: 'Musique Traditionnelle',
    date: '2026-12-19',
    venue: 'Théâtre National',
    location: 'Lomé, Togo',
    status: 'Bientôt',
    poster_url:
      'https://readdy.ai/api/search-image?query=Legendary%20African%20singer%20performing%20with%20a%20full%20traditional%20band%20under%20warm%20golden%20spotlights%20elegant%20timeless%20concert%20poster%20professional%20event%20design%20rich%20amber%20tones%20high%20detail&width=720&height=1000&seq=concert-9&orientation=portrait',
    price: '10 000 FCFA',
  },
  {
    id: 'c-10',
    artist_name: 'Joachim Migos',
    title: 'Concert Live — Tournée Gnawo',
    genre: 'Rap / Afro',
    date: '2026-09-19',
    venue: 'Palais des Congrès',
    location: 'Lomé, Togo',
    status: 'À venir',
    poster_url:
      'https://readdy.ai/api/search-image?query=African%20rap%20superstar%20performing%20on%20a%20dramatic%20concert%20stage%20with%20intense%20golden%20spotlights%20crowd%20silhouettes%20hands%20raised%20bold%20modern%20event%20poster%20rich%20warm%20amber%20tones%20high%20detail&width=720&height=1000&seq=concert-10&orientation=portrait',
    price: '10 000 FCFA',
  },
  {
    id: 'c-11',
    artist_name: 'Burna Boy',
    title: 'I Told Them Tour',
    genre: 'Afro-fusion',
    date: '2026-10-03',
    venue: 'Stade de Kégué',
    location: 'Lomé, Togo',
    status: 'À venir',
    poster_url:
      'https://readdy.ai/api/search-image?query=International%20afrobeats%20superstar%20performing%20on%20a%20massive%20stadium%20stage%20with%20pyrotechnics%20and%20a%20huge%20crowd%20dramatic%20warm%20golden%20lighting%20bold%20modern%20concert%20poster%20rich%20amber%20tones%20high%20detail&width=720&height=1000&seq=concert-11&orientation=portrait',
    price: '25 000 FCFA',
  },
  {
    id: 'c-12',
    artist_name: 'Davido',
    title: 'Timeless Tour — Lomé',
    genre: 'Afropop',
    date: '2026-11-14',
    venue: 'Hôtel 2 Février',
    location: 'Lomé, Togo',
    status: 'Bientôt',
    poster_url:
      'https://readdy.ai/api/search-image?query=Nigerian%20afropop%20star%20performing%20on%20an%20elegant%20stage%20with%20warm%20golden%20lighting%20and%20a%20huge%20enthusiastic%20crowd%20bold%20modern%20concert%20poster%20professional%20event%20design%20rich%20warm%20amber%20tones%20high%20detail&width=720&height=1000&seq=concert-12&orientation=portrait',
    price: '30 000 FCFA',
  },
  {
    id: 'c-13',
    artist_name: 'Mic Flammez',
    title: 'Le Président du Rap Game — Concert',
    genre: 'Rap',
    date: '2026-10-17',
    venue: 'Canal Olympia',
    location: 'Lomé, Togo',
    status: 'À venir',
    poster_url:
      'https://readdy.ai/api/search-image?query=Togolese%20rap%20legend%20performing%20live%20with%20microphone%20under%20dramatic%20warm%20stage%20lights%20urban%20concert%20atmosphere%20bold%20modern%20event%20poster%20rich%20golden%20tones%20high%20detail&width=720&height=1000&seq=concert-13&orientation=portrait',
    price: '8 000 FCFA',
  },
];